import { useState, useEffect } from "react";
import axios from "axios";
import { useLanguage } from "../contexts/LanguageContext";

import { API } from "../config";

const STOCK_IMAGES = [
  { url: "https://images.unsplash.com/photo-1772567732993-3c546ee1a52c?w=800&q=80", cat: "Virtuve" },
  { url: "https://images.unsplash.com/photo-1772567732989-1ddce59230e4?w=800&q=80", cat: "Virtuve" },
  { url: "https://images.unsplash.com/photo-1697946594607-04d755acff2b?w=800&q=80", cat: "Virtuve" },
  { url: "https://images.unsplash.com/photo-1719474815477-d765d3d42c9b?w=800&q=80", cat: "Telpas" },
  { url: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=800&q=80", cat: "Vannas istaba" },
  { url: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&q=80", cat: "Dzīvojamā istaba" },
  { url: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=800&q=80", cat: "Dzīvojamā istaba" },
  { url: "https://images.unsplash.com/photo-1631679706909-1844bbd07221?w=800&q=80", cat: "Vannas istaba" },
  { url: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=800&q=80", cat: "Guļamistaba" },
  { url: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&q=80", cat: "Guļamistaba" },
  { url: "https://images.unsplash.com/photo-1567538096630-e0c55bd6374c?w=800&q=80", cat: "Telpas" },
  { url: "https://images.unsplash.com/photo-1595877244574-e90ce41ce089?w=800&q=80", cat: "Kāpņu telpa" },
];

export default function GalleryPage() {
  const { t } = useLanguage();
  const cats = t("gallery_page.categories");
  const [active, setActive] = useState(Array.isArray(cats) ? cats[0] : "Visi");
  const [uploadedPhotos, setUploadedPhotos] = useState([]);

  useEffect(() => {
    axios.get(`${API}/rmd/v1/gallery`)
      .then(r => setUploadedPhotos(r.data || []))
      .catch(() => {});
  }, []);

  // Merge uploaded + stock photos
  const allImages = [
    ...uploadedPhotos.map(p => ({
      url: p.url.startsWith("http") ? p.url : `${process.env.REACT_APP_BACKEND_URL}${p.url}`,
      cat: p.category || "Citi",
      label: p.label,
      uploaded: true,
    })),
    ...STOCK_IMAGES,
  ];

  const catMap = {
    "Virtuve": "Virtuve", "Kuhnja": "Virtuve", "Kitchen": "Virtuve",
    "Vannas istaba": "Vannas istaba", "Vanna": "Vannas istaba", "Bathroom": "Vannas istaba",
    "Dzīvojamā istaba": "Dzīvojamā istaba", "Dzivojama": "Dzīvojamā istaba", "Living Room": "Dzīvojamā istaba",
    "Guļamistaba": "Guļamistaba", "Gulamistaba": "Guļamistaba", "Bedroom": "Guļamistaba",
    "Kāpņu telpa": "Kāpņu telpa", "Kapnu telpa": "Kāpņu telpa", "Stairway": "Kāpņu telpa",
    "Telpas": "Telpas", "Citi": "Citi",
  };

  const filtered = active === cats[0]
    ? allImages
    : allImages.filter(i => catMap[active] === i.cat || active === i.cat);

  return (
    <div style={{ paddingTop: 72 }} className="min-h-screen bg-white">
      <section className="bg-black py-16 px-6 md:px-12">
        <div className="max-w-6xl mx-auto">
          <span className="rmd-label text-[#FF6600] block mb-3">{t("gallery_page.title")}</span>
          <h1 className="text-white text-5xl md:text-7xl font-black uppercase tracking-tight leading-none"
            style={{ fontFamily: "Chivo, sans-serif" }} data-testid="gallery-title">
            {t("gallery_page.title")}
          </h1>
          <p className="text-white/50 mt-4 text-base">{t("gallery_page.subtitle")}</p>
        </div>
      </section>

      <div className="border-b-2 border-black bg-white sticky top-0 z-10">
        <div className="max-w-6xl mx-auto px-6 md:px-12 py-3 flex gap-2 overflow-x-auto">
          {Array.isArray(cats) && cats.map(cat => (
            <button key={cat} data-testid={`gallery-filter-${cat}`} onClick={() => setActive(cat)}
              className={`tab-btn whitespace-nowrap ${active === cat ? "active" : ""}`}>{cat}</button>
          ))}
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 md:px-12 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {filtered.map((img, i) => (
            <div key={i} data-testid="gallery-item"
              className={`overflow-hidden border-2 border-black relative ${i % 5 === 0 ? "sm:col-span-2 aspect-video" : "aspect-square"}`}>
              <img src={img.url} alt={img.label || img.cat}
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                style={{ display: "block", height: "100%" }} />
              {img.uploaded && img.label && (
                <div className="absolute bottom-0 left-0 right-0 bg-black/60 px-3 py-1.5 text-white text-xs font-semibold">
                  {img.label}
                </div>
              )}
            </div>
          ))}
          {filtered.length === 0 && (
            <div className="col-span-3 text-center py-20 text-gray-400">
              <p>Nav attēlu šajā kategorijā</p>
            </div>
          )}
        </div>
      </div>

      <footer className="bg-black py-8">
        <div className="max-w-6xl mx-auto px-6 md:px-12 text-center">
          <p className="text-white/30 text-xs">&copy; {new Date().getFullYear()} RMD – Real Men Do &middot; Cēsis, Latvija</p>
        </div>
      </footer>
    </div>
  );
}
